import { useDispatch } from "react-redux";
import { createClinician } from "../../redux/clinic/clinicSlice";
import { useCallback } from "react";
import { AppDispatch } from "../../redux";

const useCreateClinician = () => {
  const dispatch = useDispatch<AppDispatch>();

  const createClinicians = useCallback(async (cliniciansJson: any) => {
      try {
         await dispatch(createClinician(cliniciansJson ));
      } catch (error) {
        console.error('Failed to create clinicians:', error);
      }
  }, [dispatch]);

  return { createClinicians };
};

export default useCreateClinician;